import script from "./introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./introduction.vue?vue&type=script&setup=true&lang=js"

import "./introduction.vue?vue&type=style&index=0&id=17e12b15&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e12b15"]])

export default __exports__